import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalOverlay,
  ModalFooter,
  Button,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const BrandsServicesLengthErrorModal = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Errore</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>{t("promoForm.brandsServicesLengthErrorTitle")}</Text>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            {t("common.confirm")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
